<template>
  <div>
    <div v-if="product" class="product" :class="classModifier">
      <button v-if="isShopNowActive" class="product__wishlist" @click.prevent="addToWishlist()">
        <img class="product__wishlist__img" :src="wishlistSrcUrl" :alt="product.name" />
      </button>

      <div v-if="labelDiscount" class="product__label-discount">
        {{ labelDiscount }}
      </div>

      <template v-if="!rightBtnReview">
        <template v-if="!isShopNowActive">
          <a
            v-if="buttonReview && isLogin"
            href=""
            class="btn btn-dark product__button-review"
            :class="{ 'btn-black': !$store.state.screen.isDesktop }"
            @click.prevent="selectProduct('add', 'add_review')"
            >Add review</a
          >
          <a
            v-else
            href=""
            class="btn btn-dark product__button-review"
            @click.prevent="openLoginOtf('add', 'add_review')"
            >Add review</a
          >
        </template>
        <template v-else>
          <a
            target="_blank"
            rel="noopener"
            :href="product.product_url_share"
            class="btn btn-red product__button-review"
            @click="internalTrack('click', 'shop_now')"
            >Shop now</a
          >
        </template>
      </template>

      <div v-if="product.images && product.images.length" class="product__thumb">
        <router-link :to="urlDetailProduct">
          <img
            :src="mainImage(product.images[0].url)"
            class="product__img"
            :alt="`${product.name}-${product.brand.name}`"
            onerror="this.src='/assets/img/dummy_product.svg'"
          />
        </router-link>
      </div>

      <div v-else class="product__thumb">
        <router-link :to="urlDetailProduct">
          <img
            src="/assets/img/dummy_product.svg"
            class="product__img"
            :alt="`${product.name}-${product.brand.name}`"
          />
        </router-link>
      </div>

      <div class="product__info">
        <router-link v-if="product.brand.name" :to="urlDetailProduct" class="product__brand">{{
          product.brand.name
        }}</router-link>
        <router-link :to="urlDetailProduct" class="product__name">{{ convertName(productName) }}</router-link>
        <span v-if="section === 'recently-bought' && defaultCombination" class="combination">{{
          defaultCombination
        }}</span>

        <div
          v-if="
            section === 'recently-bought' &&
            product.is_reviewed !== true &&
            product.default_combination.is_verified_purchase
          "
          class="trusted-review"
        >
          <SvgImg id="trusted-review" name="trusted-review" class="trusted-review__icon" width="16" height="13" />
        </div>

        <div v-if="section === 'recently-bought' && product.is_reviewed === true" class="has-reviewed">
          <span class="red text-uppercase">REVIEWED</span>
        </div>

        <div v-if="finalPrice">
          <p class="product__final-price">{{ finalPrice }}</p>
          <p v-if="priceBeforeDiscount && discount" class="product__info-price">
            <span v-if="priceBeforeDiscount !== finalPrice" class="product-price__stroke">{{
              priceBeforeDiscount
            }}</span>
            <span v-if="discount" class="product__discount">{{ discount }}</span>
          </p>
        </div>

        <GRatingInline
          :average-rating="reviewAverageRating"
          :inline-reviewers="inlineReviewers"
          :star-fill-number="reviewStarFillNumber"
          :total-stars="isExpertReview ? 1 : undefined"
        />
        <template v-if="!hideTotalReviews">
          <p class="product__total-review">{{ totalReview }} Review{{ totalReview ? 's' : '' }}</p>
        </template>
        <a
          v-if="buttonShop && productExistsInSociolla"
          :href="product.url_sociolla"
          target="_blank"
          rel="noopener"
          class="btn product__button-shop"
          aria-label="Shop now"
          @click="internalTrack('click', 'shop_now')"
        ></a>
      </div>

      <template v-if="rightBtnReview">
        <a v-if="isLogin" href="" class="btn btn-dark" @click.prevent="selectProduct('add', 'add_review')"
          >Add review</a
        >
        <a v-else href="" class="btn btn-dark" @click.prevent="openLoginOtf('add', 'add_review')">Add review</a>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
/* eslint-disable vue/require-prop-types */
import Auth from '@/shared/auth';
export default {
  name: 'product-sociolla',
  props: {
    hideTotalReviews: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideAverageRating: {
      type: Boolean,
      required: false,
      default: false,
    },
    rightBtnReview: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonReview: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonShop: {
      type: Boolean,
      required: false,
      default: false,
    },

    product: {
      required: false,
    },
    classModifier: {
      type: String,
      required: false,
      default: '',
    },
    inlineReviewers: {
      required: false,
    },
    section: {
      required: false,
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    object_type: {
      type: String,
      required: false,
      default: '',
    },
    isExpertReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    brandNameSlug() {
      return this.product ? this.$options.filters.slug(this.product.manufacturer_name) : '';
    },
    discount() {
      return this.product.discount_range;
    },
    finalPrice() {
      return this.product.price_after_discount_range;
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isShopNowActive() {
      return (
        this.product.product_url_share &&
        this.product.available_for_order &&
        this.product.active &&
        this.product.id_product &&
        Number(this.product.stock)
      );
    },
    labelDiscount() {
      if (this.product.is_sale) {
        return `SALE`;
      } else if (this.product.discount_percentage) {
        return `${this.product.discount_percentage}%`;
      } else {
        return null;
      }
    },
    productNameSlug() {
      if (this.product.slug) {
        return this.product.slug;
      }
      return this.$options.filters.slug(this.product.product_name);
    },
    priceBeforeDiscount() {
      return this.price_range;
    },
    productExistsInSociolla() {
      return this.product.is_active_in_sociolla;
    },
    productImage() {
      /** @deprecated */
      if (this.product.image) {
        return this.product.image;
      } else if (this.product.image_cover) {
        return this.product.image_cover;
      } else {
        return '/assets/img/dummy_product.svg';
      }
    },
    productName() {
      if (this.product.name && this.product.name.length > 38 && !this.$store.state.screen.isDesktop) {
        return `${this.product.name.slice(0, 25)}...`;
      } else {
        return this.product.name;
      }
    },
    reviewAverageRating() {
      if (!this.hideAverageRating && this.product.review_stats) {
        return this.$options.filters.productrating(this.product.review_stats.average_rating);
      }
      return null;
    },
    reviewStarFillNumber() {
      if (this.product.review_stats) {
        return this.$options.filters.rating(this.product.review_stats.average_rating) * 10;
      } else {
        return 0;
      }
    },
    urlDetailProduct() {
      let result = '';
      if (this.product.default_category) {
        result = `/product/${this.$options.filters.slug(this.product.default_category.name)}/${
          this.product.id
        }-${this.$options.filters.slug(this.product.name)}`;
      } else {
        result = this.$options.filters.productUrlReview(this.product);
      }
      return result;
    },
    showingRangePrice() {
      return (
        Boolean(this.product.min_price) &&
        Boolean(this.product.max_price) &&
        this.product.min_price !== this.product.max_price
      );
    },
    showingRangePriceHaveDiscount() {
      return (
        Boolean(this.product.min_price_discount) &&
        Boolean(this.product.max_price_discount) &&
        this.product.min_price_discount !== this.product.max_price_discount
      );
    },
    socoProductId() {
      if (this.product.id) {
        return this.product.id;
      }
      if (this.product.soco_product_id) {
        return this.product.soco_product_id;
      } else if (this.product.id_product_soco) {
        return this.product.id_product_soco;
      } else {
        return 0;
      }
    },
    totalReview() {
      return this.product.review_stats.total_reviews ? this.product.review_stats.total_reviews : 0;
    },
    wishlistSrcUrl() {
      return this.product.wishlist_product
        ? `/assets/img/icons/icon-wishlist-active.svg`
        : `/assets/img/icons/icon-wishlist.svg`;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    defaultCombination() {
      if (this.product.default_combination) {
        const { attributes } = this.product.default_combination;
        const key = Object.keys(attributes);

        if (key.indexOf('non_specify') > -1) {
          return false;
        }

        const attr = key.map((val) => val + ' : ' + attributes[val].name);

        return attr.join(', ');
      }
    },
  },
  watch: {
    $route: function (to, from) {
      this.$store.dispatch('setModalSearchProduct', false);
    },
  },
  methods: {
    internalTrack(verb, object_type) {
      try {
        this.$store.dispatch('$_InternalTracking/track', {
          verb,
          object_id: this.product.id,
          object_type,
          referrer: {
            object_type: this.object_type,
          },
          target: {
            id: this.product.id,
            object_type: 'product_detail',
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    convertName(title) {
      let name = title;
      const word_length = 25;

      if (name.toString().length >= word_length) {
        name = name.toString().substr(0, word_length) + '...';
      }
      return name;
    },
    addToWishlist() {
      if (this.$store.state.auth.loggedin) {
        if (!this.product.id_product) {
          this.$toasted.global.error('Can not add this product to whishlist');
          return null;
        } else {
          if (!this.product.wishlist_product) {
            this.toggleWishlist();
            const payload = {
              id_product: this.product.id_product,
              id_product_attribute: this.product.id_default_product_attribute,
              my_sociolla_sql_id: this.product.id_product,
            };
            this.$MS_SOCO_PUBLIC_API_URL
              .post(`/wishlists`, payload)
              .then((res) => {
                if (res.status == 200) {
                  this.$toasted.global.show('Added to wishlist');
                  // eslint-disable-next-line vue/no-mutating-props
                  this.product.id_wishlist_product = res.data.data.wishlist.id_wishlist_product;
                  // eslint-disable-next-line vue/no-mutating-props
                  this.product.wishlist_product = true;
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                  this.toggleWishlist();
                }
              })
              .catch((error) => {
                this.toggleWishlist();
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              });
          } else {
            this.toggleWishlist();
            this.$MS_SOCO_PUBLIC_API_URL
              .delete(`wishlists/${this.product.id_wishlist_product}`)
              .then((response) => {
                if (response.status == '200' && response.data.data) {
                  this.$toasted.global.show('Wishlist berhasil didelete.');
                } else {
                  this.toggleWishlist();
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
              })
              .catch((error) => {
                this.toggleWishlist();
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              });
          }
        }
      } else {
        this.openLoginOtf();
      }
    },
    openLoginOtf(verb, object_type) {
      this.internalTrack(verb, object_type);
      Auth.CentralAuth.login();
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=169',
        image: src,
      });
    },
    submainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=50',
        image: src,
      });
    },
    ownerImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=30',
        image: src,
      });
    },
    selectProduct(verb, object_type) {
      this.internalTrack(verb, object_type);
      const notInReviewPage = !/review[/]add/.test(this.$route.path);
      if (notInReviewPage) {
        this.$router.push(`/review/add/${this.socoProductId}`);
      }
      this.$store.dispatch('setDataSelectedProduct', {
        dataSelectedProduct: this.product,
        component: this,
      });
    },
    toggleWishlist() {
      // eslint-disable-next-line vue/no-mutating-props
      this.product.wishlist_product = !this.product.wishlist_product;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-black {
  border: solid 1px #231f20 !important;
  color: #231f20 !important;
}
</style>
